import { render, staticRenderFns } from "./userMyCollection.vue?vue&type=template&id=b5812fb8&scoped=true"
import script from "./userMyCollection.vue?vue&type=script&lang=js"
export * from "./userMyCollection.vue?vue&type=script&lang=js"
import style0 from "./userMyCollection.vue?vue&type=style&index=0&id=b5812fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5812fb8",
  null
  
)

export default component.exports